import { render, staticRenderFns } from "./SendSI.vue?vue&type=template&id=481876ac&scoped=true&"
import script from "./SendSI.vue?vue&type=script&lang=js&"
export * from "./SendSI.vue?vue&type=script&lang=js&"
import style0 from "./SendSI.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SendSI.vue?vue&type=style&index=1&id=481876ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481876ac",
  null
  
)

export default component.exports